type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

/**
 * Solid play glyph — filled disc with a knocked-out triangle. The transport
 * play button used by the Creator Studio stage and the clip preview bar.
 * Distinct from `CirclePlayIcon` (thin outline ring variant).
 */
const CirclePlayFilledIcon = (props: Props) => {
  const { width = '32', height = '32', fillColor = 'currentColor' } = props;
  return (
    <svg viewBox="0 0 24 24" fill={fillColor} width={width} height={height}>
      <path
        fillRule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default CirclePlayFilledIcon;
